// extracted by mini-css-extract-plugin
module.exports = {"textPerson":"SettingsDialog_textPerson__y6RA_","paramRow":"SettingsDialog_paramRow__2EPXZ","check":"SettingsDialog_check__1ogH-"};